<template>
  <div>
    <div class="toggle-profile-sharing" v-if="isSharingProfile">
      <input
        v-model="isSharingProfile.shareUserProfileWithOrganisation"
        :value="isSharingProfile.shareUserProfileWithOrganisation"
        @change="submitUserSharingSettings"
        type="checkbox"
        class="toggle-switch-checkbox"
        id="share-profile-toggle"
        name="share-profile-toggle"
        data-test="share-profile-toggle"
      />
      <label for="share-profile-toggle" class="toggle-label"
        >Allow other members in your organisation to see your profile?</label
      >
    </div>
    <div class="btn-container">
      <router-link
        :to="`/user/profile/${props.userId}`"
        class="btn btn-default"
        data-test="view-my-profile"
        >View my profile</router-link
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
import { defineProps, ref, onBeforeMount } from "vue";
import axios from "axios";
import { debug as d } from "debug";
import { UserSharingSettingsApiModel } from "../../api-models";

const debug = d("cs.ProfileSettings");

const props = defineProps<{ userId: string }>();

const isSharingProfile = ref<UserSharingSettingsApiModel | null>(null);

async function getUserSharingSettings() {
  try {
    const response = await axios.get("/api/usersharingsettings");
    isSharingProfile.value = response.data;
  } catch (e) {
    debug(e);
  }
}

async function submitUserSharingSettings() {
  try {
    await axios.post("/api/usersharingsettings", isSharingProfile.value);
  } catch (e) {
    debug(e);
  }
}

onBeforeMount(async () => {
  await getUserSharingSettings();
});
</script>

<style scoped lang="less">
@import (reference) "../../styles/bootstrap/bootstrap.less";
@import (reference) "../../styles/bootstrap/variables.less";

.toggle-profile-sharing {
  display: flex;
  gap: 2rem;
  align-items: center;

  @media (max-width: @screen-xs-max) {
    flex-direction: column-reverse;
  }
}

.toggle-label {
  color: @form-text-color;
  font-weight: normal;
  margin-bottom: 0;
}

.btn-container {
  display: flex;
  justify-content: center;
  margin-block: 5rem;
}
</style>
